const actionsPrefix = 'InformParticipation_';

function buildAction(actionName) {
  return actionsPrefix + actionName;
}

const INIT = buildAction('INIT');
const INIT_FINISH = buildAction('INIT_COMPLETE');
const RESET_INITIAL = buildAction('RESET_INITIAL');

export const informParticipationActionTypes = {
  INIT,
  INIT_FINISH,
  RESET_INITIAL,
};

export const informParticipationActions = {
  initAction: () => ({ type: INIT }),
  initFinishAction: () => ({ type: INIT_FINISH }),
  resetInitial: () => ({ type: RESET_INITIAL }),
};
